import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE, timeout: 30000 });

// Attach the appropriate token: admin token for /admin/* routes, else user token
api.interceptors.request.use((config) => {
  const url = config.url || "";
  const adminToken = localStorage.getItem("hsg_admin_token");
  const userToken = localStorage.getItem("hsg_user_token");
  const isAdmin = url.startsWith("/admin") || url.startsWith("admin");
  const token = isAdmin ? adminToken : (userToken || adminToken);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err?.config?.url || "";
      if (url.includes("/admin")) {
        localStorage.removeItem("hsg_admin_token");
        localStorage.removeItem("hsg_admin_meta");
      } else {
        localStorage.removeItem("hsg_user_token");
        localStorage.removeItem("hsg_user");
      }
    }
    return Promise.reject(err);
  }
);

export default api;
